import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1A237E',
        accent: '#5B13B0',
        info: '#2A38C9',
        error: '#7D2727',
        success: '#147D32',
        warning: '#B06F13',
      },
    },
  },
});
